import {useMutation} from '@tanstack/react-query';
import {useCallback, useState} from 'react';
import {useForm} from 'react-hook-form';
import {ReportApi, ReportParams} from '../../api';
import {useMerchant, useProfile} from '../../hooks';
import {formatDateForInput} from '../../utils';
import {useTerminalStore} from '../../store';
import {LoadingButton} from '../atoms';

export const ChargebackReportCard = () => {
  const merchant = useMerchant();
  const profile = useProfile();
  const [error, setError] = useState<string | null>(null);

  const { terminalId } = useTerminalStore();
  const { handleSubmit, register, watch } = useForm<ReportParams>();

  const periodStart = watch('periodStart');
  const periodEnd = watch('periodEnd');

  const { mutate, isPending } = useMutation({
    mutationFn: ReportApi.adjustment,
  });

  const onSubmit = useCallback(
    (data: ReportParams) => {
      setError(null);

      if (!terminalId || terminalId === '') {
        setError('Please select a terminal. ALL TERMINALS is not allowed.');
        return;
      }

      if (merchant) {
        mutate({
          ...data,
          terminalId,
        });
      }
    },
    [merchant, terminalId, mutate],
  );

  if (!profile || !profile.permissions.includes('report.read.adjustment')) {
    return null;
  }

  return (
    <li className="p-4 rounded-2xl shadow-1 bg-white flex flex-col min-w-[280px]">
      <h2 className="mb-5 text-lg font-bold text-center">Chargeback</h2>
      <form className="grid gap-5 h-full" onSubmit={handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-4">
          <label>
            <span className="mb-1 block text-brand-2 text-sm pl-4">Date From</span>
            <input
              {...register('periodStart', {
                required: true,
                valueAsDate: true,
              })}
              className="input w-full"
              max={formatDateForInput(new Date(periodEnd))}
              type="date"
            />
          </label>
          <label>
            <span className="mb-1 block text-brand-2 text-sm pl-4">Date To</span>
            <input
              {...register('periodEnd', {
                required: true,
                valueAsDate: true,
              })}
              className="input w-full"
              min={formatDateForInput(new Date(periodStart))}
              type="date"
            />
          </label>
        </div>
        {error && (
          <div className="text-red text-sm pl-4">
            {error}
          </div>
        )}
        <LoadingButton
          isLoading={isPending}
          type="submit"
        >
          Get report
        </LoadingButton>
      </form>
    </li>
  );
};
